var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_569_6048)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.875 4.375C1.875 3.87772 2.07254 3.40081 2.42417 3.04917C2.77581 2.69754 3.25272 2.5 3.75 2.5H11.25C11.7473 2.5 12.2242 2.69754 12.5758 3.04917C12.9275 3.40081 13.125 3.87772 13.125 4.375V10.625C13.125 11.1223 12.9275 11.5992 12.5758 11.9508C12.2242 12.3025 11.7473 12.5 11.25 12.5H3.75C3.25272 12.5 2.77581 12.3025 2.42417 11.9508C2.07254 11.5992 1.875 11.1223 1.875 10.625V4.375Z",
    stroke: "#2D2D2D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.375 6.25C4.375 6.58152 4.5067 6.89946 4.74112 7.13388C4.97554 7.3683 5.29348 7.5 5.625 7.5C5.95652 7.5 6.27446 7.3683 6.50888 7.13388C6.7433 6.89946 6.875 6.58152 6.875 6.25C6.875 5.91848 6.7433 5.60054 6.50888 5.36612C6.27446 5.1317 5.95652 5 5.625 5C5.29348 5 4.97554 5.1317 4.74112 5.36612C4.5067 5.60054 4.375 5.91848 4.375 6.25Z",
    stroke: "#2D2D2D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.375 5H10.625",
    stroke: "#2D2D2D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.375 7.5H10.625",
    stroke: "#2D2D2D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.375 10H10.625",
    stroke: "#2D2D2D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_569_6048"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactInfo);
export default __webpack_public_path__ + "static/media/contactInfo.4c5888efec98fd47eef5e7b95f1f87bf.svg";
export { ForwardRef as ReactComponent };